import { apiFetch } from "./client";

export const adminApi = {
  getUsers: () => apiFetch("/admin/users"),
  createAdmin: (payload) =>
    apiFetch("/admin/create-admin", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
};
